import { apiFetch } from './apiFetch';

export async function followupStatus(tid) {
  try {
    const response = await apiFetch(
      `/followup/status?tid=${encodeURIComponent(tid)}`,
      {
        method: 'GET',
      },
    );
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching followup status:', error);
    throw error;
  }
}

export async function createRefund(transaction_id, card_number) {
  try {
    const response = await apiFetch('/followup/refund', {
      method: 'POST',
      body: JSON.stringify({ transaction_id, card_number }),
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error creating refund:', error);
    throw error;
  }
}
